// extracted by mini-css-extract-plugin
export default {"label":"InputLabel_label__Y7mnp","asterisk":"InputLabel_asterisk__y1zbo","errorText":"InputLabel_errorText__BpM2n"};